import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { PathPolicySideMenuRef } from '../../components/PathPolicy'
import { PathPolicyForm } from '../../components/PathPolicy'

interface Props {
  sideMenuRef: React.RefObject<PathPolicySideMenuRef>
}

const PathPolicyPage = ({ sideMenuRef }: Props): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Path Policy</title>
      <meta name="description" content="Path Policy page" />
    </Helmet>
    <PathPolicyForm sideMenuRef={sideMenuRef} />
  </React.Fragment>
)

export default PathPolicyPage
